/* eslint-disable no-void */

import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios, { CancelTokenSource } from 'axios';

import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.ApiResponse | undefined,
  (requestParams: vp.WorkflowDeleteRequest) => void,
  (requestParams: vp.WorkflowDeleteRequest) => Promise<vp.ApiResponse>,
  () => void,
];

function useDeleteWorkflow({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.WorkflowDeleteRequest>();
  const [response, setResponse] = useState<vp.ApiResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  useEffect(() => {
    const sendRequest = async (requestParams: vp.WorkflowDeleteRequest, cancelTokenSource: CancelTokenSource) => {
      const res = await api.deleteWorkflow(requestParams, cancelTokenSource);

      setResponse(res);
      setSendRequest(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params, source);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.WorkflowDeleteRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    async (requestParams: vp.WorkflowDeleteRequest) => {
      const res = await api.deleteWorkflow(requestParams, source);
      return res;
    },
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useDeleteWorkflow);
